export default __webpack_public_path__ + "static/media/ss-team-profile-generator.5f1bc962.png";